import React from 'react';
import config from 'config';

const { GTAG } = config;

export default class GoogleTagManager extends React.Component {
  componentDidMount() {
    // DOM: Create the script element
    const jsElm = document.createElement('script');
    jsElm.type = 'application/javascript';
    // make the script element load file
    jsElm.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG.id}`;
    jsElm.async = true;
    document.body.appendChild(jsElm);
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GTAG.id);
  }
  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/GoogleTagManager/GoogleTagManager.jsx